import React from 'react';

// import CondomAvatar from '../../../../images/avatar/condom.png';
// import LipsAvatar from '../../../../images/avatar/lips.png';
// import DevilHeartAvatar from '../../../../images/avatar/devil-heart.png';
// import HeartAvatar from '../../../../images/avatar/heart.png';
// import DefaultAvatar from '../../../../images/default_avatar.png';
import {Button} from "../../Button";
import Modal from "../../Modal";
import UploaderAC from "../../upload/UploadAC";
import Avatar from "../../Avatar";

class AskAvatar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentAvatarSelection: 0,
            uploadAvatar: false,
        }
        this.handleData = this.handleData.bind(this);
    }

    handleData(value){
        this.props.handleData(value);
    }

    render() {
        // let avatarList = [CondomAvatar, LipsAvatar, DevilHeartAvatar, HeartAvatar, DefaultAvatar];
        return (
            <div id={"askAvatar"}>
                <div className={"catch-phrase"}>10x plus de chances de retenir l'attention !</div>
                {/*<div className={"avatar-titles"}>*/}
                {/*    <div className={`avatar-section-title ${this.state.currentAvatarSelection === 0 ? 'active' : ''}`}*/}
                {/*         onClick={() => this.setState({currentAvatarSelection: 0})}>Personnalisé :*/}
                {/*    </div>*/}
                {/*    <div className={`avatar-section-title ${this.state.currentAvatarSelection === 1 ? 'active' : ''}`}*/}
                {/*         onClick={() => this.setState({currentAvatarSelection: 1})}>Par défaut :*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div className={`column ${this.state.currentAvatarSelection === 0 ? 'show' : 'hide'}`}>
                    <div className={"avatar add"}>
                        <Avatar gender={this.props.gender} avatar={this.props.avatar} width={150} height={150}/>
                    </div>
                    <div className={"button-add-avatar"}>
                        <Button btnStyle={"primary-reverse"}
                                onClick={()=>this.setState({uploadAvatar: true})}
                                content={"Ajouter votre avatar"}/>
                    </div>
                    <Modal toggle={this.state.uploadAvatar}
                           handleClose={() => this.setState({uploadAvatar: false})}>
                        <UploaderAC type={"avatar"}

                                    uploadPath={"/users/me/upload-avatar"}
                                    handleData={this.handleData}
                                    handleClose={() => this.setState({uploadAvatar: false})}/>
                    </Modal>
                </div>
                {/*<div className={`column ${this.state.currentAvatarSelection === 1 ? 'show' : 'hide'}`}>*/}
                {/*    <div className={"default-avatar-list"}>*/}
                {/*        {avatarList.map((item, index) => (*/}
                {/*            <div className={`default-avatar ${this.props.avatar === item ? 'active' : ''}`} key={index}>*/}
                {/*                <img onClick={() => this.props.handleData("avatar", item)} src={item} alt={""}/>*/}
                {/*            </div>*/}
                {/*        ))}*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        )
    }
}

export default AskAvatar;